import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const currentYear = new Date().getFullYear()

export const usePeriodGrafStore = create(
  persist(
    set => ({
      mode: 'ROK',
      year: currentYear,
      yearFrom: currentYear - 9,
      yearTo: currentYear,
      multiSelect: false,
      selectedChips: ['ROK'],
      activeTab: 'graf',
      chartFormat: 'png',
      interactive: false,

      setMode: mode => set({ mode }),
      setYear: year => set({ year }),
      setYearFrom: yearFrom => set({ yearFrom }),
      setYearTo: yearTo => set({ yearTo }),
      setMultiSelect: multiSelect => set({ multiSelect, selectedChips: [] }),
      setSelectedChips: selectedChips => set({ selectedChips }),
      setActiveTab: activeTab => set({ activeTab }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'period-graf-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
